import { render, staticRenderFns } from "./list-extract.vue?vue&type=template&id=1223b754&"
import script from "./list-extract.vue?vue&type=script&lang=js&"
export * from "./list-extract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports